import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import config from "configs/config";
import apiClient from "lib/api-client";

const fetchAICollections = async (payload) => {
  const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getAICollections`, payload);
  return response.data;
};

const useGetAICollections = (payload) => {
  return useQuery({
    queryKey: ["aicollections", payload],
    queryFn: () => fetchAICollections(payload),
    enabled: !!payload,
    refetchOnWindowFocus: false,
  });
};

export default useGetAICollections;
